import { radiusPx } from '../../../theme/tokens/radius';

/**
 * Unified Intervene surface radii — keep controls, cards, and bubbles consistent.
 */
export const interveneRadius = {
  /** Inputs, dropdowns, tabs, buttons */
  control: radiusPx.md,
  /** Panels, composer bar, list rows */
  surface: radiusPx.lg,
  /** Message bubbles — soft pill corners like reference UI */
  bubble: '18px',
  /** Bubble grouped tail corners */
  bubbleTail: '4px',
  /** Option chips / small badges */
  chip: radiusPx.sm,
};

export const CONTEXT_AREA_SPLIT = { chat: '67%', drawer: '35%' };
export const CONTEXT_FLEX_RATIO = { chat: 11, drawer: 9 };

export const CONTEXT_DRAWER_WIDTH = { md: 360, lg: 400, xl: 420 };
export const USER_LIST_WIDTH = { md: 360, xl: 390 };

export const interveneBubbleShape = {
  mineSingle: `${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.bubbleTail} ${interveneRadius.bubble}`,
  mineFirst: `${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.chip} ${interveneRadius.bubble}`,
  mineMiddle: `${interveneRadius.bubble} ${interveneRadius.chip} ${interveneRadius.chip} ${interveneRadius.bubble}`,
  mineLast: `${interveneRadius.bubble} ${interveneRadius.chip} ${interveneRadius.bubbleTail} ${interveneRadius.bubble}`,
  theirSingle: `${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.bubbleTail}`,
  theirFirst: `${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.chip}`,
  theirMiddle: `${interveneRadius.chip} ${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.chip}`,
  theirLast: `${interveneRadius.bubbleTail} ${interveneRadius.bubble} ${interveneRadius.bubble} ${interveneRadius.bubble}`,
  attachment: interveneRadius.bubble,
};
